import { ActionReducerMap } from "@ngrx/store";

import { ModelState } from "./model/state";
import { modelReducer } from "./model/reducer";

import { ValidityState } from "./validity/state";
import { validityReducer } from "./validity/reducer";

import { ProductIndexState } from "./product-index/state";
import { productIndexReducer } from "./product-index/reducer";

import { DocumentState } from "./document/state";
import { documentReducer } from "./document/reducer";

import { SearchState } from "./search/state";
import { searchReducer } from "./search/reducer";

import { ViewState } from "./view/state";
import { viewReducer } from "./view/reducer";

export interface RootState {
    model: ModelState;
    validity: ValidityState;
    productIndex: ProductIndexState;
    document: DocumentState;
    search: SearchState;
    view: ViewState;
}

export const rootReducerMap: ActionReducerMap<RootState> = {
    model: modelReducer,
    validity: validityReducer,
    productIndex: productIndexReducer,
    document: documentReducer,
    search: searchReducer,
    view: viewReducer,
};
